import React from "react";

export default function YoutubeIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.551 1.998H8.64c.822.003 4.987.034 6.11.335.689.185 1.23.73 1.415 1.42.101.38.172.884.22 1.403l.01.104.022.26.008.103c.065.914.073 1.77.074 1.957v.076c-.001.194-.01 1.108-.082 2.06l-.008.104-.009.104c-.05.573-.124 1.141-.235 1.559a2.007 2.007 0 0 1-1.415 1.42c-1.16.311-5.569.333-6.18.335H8.428c-.309-.001-1.587-.007-2.927-.053l-.17-.006a24.459 24.459 0 0 0-.087-.003l-.171-.007-.171-.007c-1.11-.05-2.167-.129-2.654-.26a2.007 2.007 0 0 1-1.415-1.42c-.111-.417-.185-.985-.235-1.558L.59 9.82l-.008-.104A31.4 31.4 0 0 1 .5 7.68v-.124c.002-.214.01-.958.064-1.778l.007-.103.003-.052.008-.103.022-.26.01-.104c.048-.52.119-1.024.22-1.403a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.259l.17-.007.172-.007.086-.003.171-.006a99.788 99.788 0 0 1 2.857-.053h.193ZM6.9 5.209v4.817l4.157-2.408-4.157-2.409Z"
        fill="red"
      />
    </svg>
  );
}
